import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import createJourneySchema, { CreateJourneyType } from './schema';
import { FormPropsInterface } from './FormTypes';
import Form from './Form';

function FormContainer({
  actionsInnerRef,
  onCancel,
  onSuccess,
}: FormPropsInterface) {
  const cancelJourneyHook = useForm<CreateJourneyType>({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    resolver: zodResolver(createJourneySchema),
  });

  return (
    <FormProvider {...cancelJourneyHook}>
      <Form
        actionsInnerRef={actionsInnerRef}
        onCancel={onCancel}
        onSuccess={onSuccess}
      />
    </FormProvider>
  );
}

export default FormContainer;
